import React, { useContext, useState } from "react";
import { UserContext } from "../../contexts/userContext";
import { Grid, TextField, MenuItem, Button, FormControlLabel, Checkbox, Paper, Typography } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { MARKETPLACE } from "../../utils/constants";

interface QuoteAuditsFiltersProps {
  merchants: Array<{ id: number; name: string }>;
  onFilter: (_filters: {
    fromDate?: string;
    toDate?: string;
    merchantId?: number;
    allResponsesFailed?: boolean;
  }) => void;
}

const QuoteAuditsFilters: React.FC<QuoteAuditsFiltersProps> = ({ merchants, onFilter }) => {
  const { currentUser } = useContext(UserContext);
  const [fromDate, setFromDate] = useState<string>("");
  const [toDate, setToDate] = useState<string>("");
  const [merchantId, setMerchantId] = useState<number | "">("");
  const [allResponsesFailed, setAllResponsesFailed] = useState<boolean>(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onFilter({
      fromDate,
      toDate,
      merchantId: merchantId === "" ? undefined : merchantId,
      allResponsesFailed,
    });
  };

  const handleClear = () => {
    setFromDate("");
    setToDate("");
    setMerchantId("");
    setAllResponsesFailed(false);
    onFilter({});
  };

  return (
    <Paper sx={{ p: 2, mb: 2, mt: 2, boxShadow: "none", border: "none" }}>
      <Typography variant="h6" sx={{ mb: 2, fontWeight: 700, letterSpacing: 1, display: "flex", alignItems: "center", color: "rgba(0, 0, 0, 0.87)" }}>
        Filtros de Auditoría de Cotizaciones
      </Typography>
      <Grid container alignItems="center" spacing={2}>
        <Grid item xs={12} sm={6} md={2}>
          <LocalizationProvider dateAdapter={AdapterLuxon}>
            <DatePicker
              label="Desde"
              value={fromDate || null}
              disableFuture
              onChange={(newValue: any) => setFromDate(newValue)}
              renderInput={(params) => (
                <TextField fullWidth size="small" {...params} />
              )}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <LocalizationProvider dateAdapter={AdapterLuxon}>
            <DatePicker
              label="Hasta"
              value={toDate || null}
              disableFuture
              onChange={(newValue: any) => setToDate(newValue)}
              renderInput={(params) => (
                <TextField fullWidth size="small" {...params} />
              )}
            />
          </LocalizationProvider>
        </Grid>
        {currentUser?.entity === MARKETPLACE && (
          <Grid item xs={12} sm={6} md={2}>
            <TextField
              label="Merchant"
              select
              value={merchantId}
              onChange={(e) => setMerchantId(Number(e.target.value))}
              fullWidth
              size="small"
            >
              <MenuItem value="">Todos</MenuItem>
              {merchants.map((m) => (
                <MenuItem key={m.id} value={m.id}>{m.name}</MenuItem>
              ))}
            </TextField>
          </Grid>
        )}
        <Grid item xs={12} sm={6} md={2}>
          <FormControlLabel
            control={
              <Checkbox
                checked={allResponsesFailed}
                onChange={(e) => setAllResponsesFailed(e.target.checked)}
                color="primary"
              />
            }
            label="Fallo general"
          />
        </Grid>
        <Grid item xs={12} sm={12} md={4} sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 2 }}>
          <Button type="button" variant="contained" color="primary" sx={{ fontWeight: 600 }} onClick={handleSubmit}>
            Filtrar
          </Button>
          <Button
            type="button"
            onClick={handleClear}
            variant="outlined"
            sx={{ fontWeight: 600, borderColor: "primary", color: "primary" }}
          >
            Limpiar
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default QuoteAuditsFilters;
